import rtfToHTML from '@iarna/rtf-to-html';
import addLastBullet from 'legacyfrontend/utils/add-last-bullet';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useInformation = (description) => {
  const { t } = useTranslation(['layout']);
  const [preparedInformation, setPreparedInformation] = useState();

  useEffect(() => {
    if (description) {
      if (description.includes('charset')) {
        rtfToHTML.fromString(
          description.replace('fcharset238', 'fcharset0').replace('fcharset2', 'fcharset0'),
          {
            template: (_doc, _defaults, content) => content,
          },
          (err, html) => {
            setPreparedInformation(
              err
                ? t('packages.info_not_available')
                : addLastBullet(
                    html.replace(/·/g, '<i class="fa fa-check-circle icon-bullet"></i>'),
                    'icon-bullet'
                  )
            );
          }
        );
      } else {
        setPreparedInformation(description);
      }
    }
  }, [description]);

  return preparedInformation;
};

export default useInformation;
